import React from 'react';
import { Field, reduxForm } from 'redux-form';
import Checkbox from '../../../shared/form-elements/checkbox';

class Form extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { toggleShowAll } = this.props;
		return (
			<form>
				<div className="ui-form__element margin-10-15">
					<Field
						name="is_showed_all"
						placeholder={'Show all?'}
						component={Checkbox}
						onChange={toggleShowAll}
					/>
				</div>
			</form>
		);
	}
}

export default reduxForm({ form: 'garantForecastFilterForm'})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/garant-forecast/components/filter-form/main.js